import { h } from 'preact'
import UserAvatar from '../User/UserAvatar'
import { common } from '../common'

interface TopicBannerData {
  author?: {
    url: string
    name: string
    avatar: string
  }
  createdAt?: string
  publishedAt?: string
  post: {
    author: {
      url: string
      name: string
      avatar: string
    }
    relativeCreationDate: string
  }
  url: string
  title: string
}

interface Props {
  selectedTopic: TopicBannerData
}

const TopicBanner = ({ selectedTopic }: Props) => {
  if (!selectedTopic) {
    return null
  }

  const author = selectedTopic.author ?? selectedTopic.post.author
  const relativeDate = selectedTopic.publishedAt ? common.relativeDate(new Date(selectedTopic.publishedAt).getTime()) : selectedTopic.createdAt ? common.relativeDate(new Date(selectedTopic.createdAt).getTime()) : selectedTopic.post.relativeCreationDate

  return (
    <div className='topic-banner_wrapper featuredBanner'>
      <a className='banner-notification_url' href={selectedTopic.url} />
      <div className='box banner-notification notification'>
        <div className='box__content box__pad'>
          <p className='notification-title'>
            <span className='notification-link'>
              {selectedTopic.title.length > 100 ? selectedTopic.title.substring(0, 100) + '...' : selectedTopic.title}
            </span>
          </p>
          <span className='thread-meta-item'>
            <UserAvatar
              user={author}
              extraClass='avatar avatar--S'
              showRank
            />
            <span className='notification-link'>
              <span className='thread-meta-item__date'>
                {relativeDate}
              </span>
            </span>
          </span>
        </div>
      </div>
    </div>
  )
}

export default TopicBanner
